<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectProgress"
        :isOverdue="isOverdue"
        :quantity="dashboard.reservations_kpi"
        :title="$tc('Reservation Confirmée')"
        :to="toProjectTaskEdit"
      />
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectTasksRemaining"
        :quantity="dashboard.all_reservations_kpi"
        :title="$tc('Total Reservation')"
        :to="toAllProjectActions"
      />
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectInspectionsRemaining"
        :quantity="dashboard.customers_kpi"
        :title="$t('Total Client')"
        :to="toInspections"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectNonconformities"
        :quantity="dashboard.expense_kpi"
        :title="$tc('Total Depense')"
        :to="toNonConformities"
      />
    </v-col>
  </v-row>
</template>

<script>
import KpiCardComponent from "@/components/ri3/KpiCardComponent.vue"
import { getAssets } from "@/plugins/vuetify"

export default {
  name: "ProjectKPI",
  components: {
    KpiCardComponent
  },
  props: {
    dashboard: {
      type: Object
    },
    projectId: {
      type: String,
      required: true
    }
  },
  computed: {
    assets() {
      return getAssets(this)
    },
    isOverdue() {
      return this.dashboard.progression > 100
    }
  },
  data() {
    return {
      toInspections: { name: "Customers" },
      toNonConformities: { name: "AuthorisationDetail" },
      toProjectTaskEdit: {
        name: "Reservations"
      },
      toAllProjectActions: { name: "Reservations" }
    }
  }
}
</script>
